var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 1.01121C23.9555 1.76409 22.7988 2.33993 21.5747 2.71654C20.9177 1.9447 20.0445 1.39763 19.0733 1.14934C18.102 0.901042 17.0796 0.963498 16.1442 1.32826C15.2088 1.69302 14.4057 2.34249 13.8434 3.18882C13.281 4.03515 12.9867 5.03751 13.0001 6.06034V7.17494C11.083 7.22573 9.18327 6.79131 7.47024 5.91037C5.75721 5.02942 4.28401 3.72931 3.18183 2.12581C3.18183 2.12581 -1.18183 12.1572 8.63642 16.6156C6.38971 18.1738 3.71328 18.9551 1 18.8448C10.8183 24.4178 22.8183 18.8448 22.8183 6.0269C22.8173 5.71643 22.7881 5.40673 22.7311 5.10178C23.8445 3.97993 24.6302 2.56352 25.0002 1.01121V1.01121Z",
    stroke: "var(--klothed-textColor)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ae7c001642f44b2a513872aab284b2de.svg";
export { ForwardRef as ReactComponent };